import React, { useContext } from 'react';

import HolidaysTable from './HolidaysTable';

import SettingsContext, { type CompanyHoliday } from '@/Contexts/Settings/Context';

const CompanyHolidaysSection: React.FC = () => {
  const { companyHolidays, handleCompanySettingChange } = useContext(SettingsContext);
  const holidays: CompanyHoliday[] = JSON.parse(companyHolidays || '[]');

  const handleChange = (updated: CompanyHoliday[]) => {
    handleCompanySettingChange('company_holidays', JSON.stringify(updated));
  };

  return <HolidaysTable holidays={holidays} onChange={handleChange} titlePrefix="Company" />;
};

export default CompanyHolidaysSection;
